import addressbooks from './resources/addressbooks';
import Client from './Client';
import locations from './resources/locations';
import order from './resources/order';
import orders from './resources/orders';
import products from './resources/products';
import regions from './resources/regions';
import additions from './resources/additions';
import certificate from './resources/certificate';
import services from './resources/services';
import user from './resources/user';
import auth from './resources/auth';
import tenants from "./resources/tenants";

export default function createClient(config = {}) {
    const client = new Client(config);
    return client
        .register('addressbooks', addressbooks)
        .register('auth', auth)
        .register('locations', locations)
        .register('order', order)
        .register('orders', orders)
        .register('products', products)
        .register('regions', regions)
        .register('additions', additions)
        .register('certificate', certificate)
        .register('services', services)
        .register('tenants', tenants)
        .register('user', user);
}
